import SEOHead from '../../components/SEOHead';
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Prefecture {
  name: string;
  count: number;
  color: string;
}

interface Region {
  name: string;
  prefectures: Prefecture[];
}

export default function StoreSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPrefecture, setSelectedPrefecture] = useState<string | null>(null);

  const regions: Region[] = [
    {
      name: '北海道・東北',
      prefectures: [
        { name: '北海道', count: 0, color: 'bg-gray-200' },
        { name: '青森県', count: 0, color: 'bg-gray-200' },
        { name: '岩手県', count: 0, color: 'bg-gray-200' },
        { name: '宮城県', count: 0, color: 'bg-gray-200' },
        { name: '秋田県', count: 0, color: 'bg-gray-200' },
        { name: '山形県', count: 0, color: 'bg-gray-200' },
        { name: '福島県', count: 0, color: 'bg-gray-200' }
      ]
    },
    {
      name: '関東',
      prefectures: [
        { name: '茨城県', count: 0, color: 'bg-gray-200' },
        { name: '栃木県', count: 0, color: 'bg-gray-200' },
        { name: '群馬県', count: 0, color: 'bg-gray-200' },
        { name: '埼玉県', count: 0, color: 'bg-gray-200' },
        { name: '千葉県', count: 0, color: 'bg-gray-200' },
        { name: '東京都', count: 0, color: 'bg-gray-200' },
        { name: '神奈川県', count: 0, color: 'bg-gray-200' }
      ]
    },
    {
      name: '中部',
      prefectures: [
        { name: '新潟県', count: 0, color: 'bg-gray-200' },
        { name: '富山県', count: 0, color: 'bg-gray-200' },
        { name: '石川県', count: 17, color: 'bg-green-300' },
        { name: '福井県', count: 24, color: 'bg-green-400' },
        { name: '山梨県', count: 0, color: 'bg-gray-200' },
        { name: '長野県', count: 49, color: 'bg-pink-300' },
        { name: '岐阜県', count: 42, color: 'bg-pink-300' },
        { name: '静岡県', count: 205, color: 'bg-pink-400' },
        { name: '愛知県', count: 76, color: 'bg-blue-300' }
      ]
    },
    {
      name: '関西',
      prefectures: [
        { name: '三重県', count: 24, color: 'bg-blue-300' },
        { name: '滋賀県', count: 19, color: 'bg-blue-300' },
        { name: '京都府', count: 86, color: 'bg-blue-400' },
        { name: '大阪府', count: 26, color: 'bg-blue-300' },
        { name: '兵庫県', count: 50, color: 'bg-blue-400' },
        { name: '奈良県', count: 20, color: 'bg-blue-300' },
        { name: '和歌山県', count: 24, color: 'bg-blue-300' }
      ]
    },
    {
      name: '中国・四国',
      prefectures: [
        { name: '鳥取県', count: 14, color: 'bg-green-300' },
        { name: '島根県', count: 9, color: 'bg-green-300' },
        { name: '岡山県', count: 29, color: 'bg-green-400' },
        { name: '広島県', count: 30, color: 'bg-green-400' },
        { name: '山口県', count: 7, color: 'bg-green-300' },
        { name: '徳島県', count: 33, color: 'bg-yellow-300' },
        { name: '香川県', count: 29, color: 'bg-yellow-300' },
        { name: '愛媛県', count: 12, color: 'bg-yellow-300' },
        { name: '高知県', count: 35, color: 'bg-yellow-300' }
      ]
    },
    {
      name: '九州・沖縄',
      prefectures: [
        { name: '福岡県', count: 116, color: 'bg-purple-300' },
        { name: '佐賀県', count: 77, color: 'bg-purple-300' },
        { name: '長崎県', count: 86, color: 'bg-purple-300' },
        { name: '熊本県', count: 80, color: 'bg-purple-300' },
        { name: '大分県', count: 56, color: 'bg-purple-300' },
        { name: '宮崎県', count: 49, color: 'bg-purple-300' },
        { name: '鹿児島県', count: 55, color: 'bg-purple-300' },
        { name: '沖縄県', count: 43, color: 'bg-purple-300' },
        { name: '愛媛県', count: 19, color: 'bg-purple-300' },
        { name: '福島県', count: 38, color: 'bg-purple-300' }
      ]
    }
  ];

  const totalStores = regions.reduce((total, region) => 
    total + region.prefectures.reduce((regionTotal, pref) => regionTotal + pref.count, 0), 0
  );

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // 検索処理をここに実装
    console.log('検索:', searchQuery);
  };

  return (
    <>
      <SEOHead
        title="店舗検索 - LiMU | 全国の提携スタジオを検索"
        description="LiMUの提携スタジオを全国から検索できます。お近くのフォトスタジオで3D手足アートの型取りをお楽しみください。"
        keywords="LiMU,店舗検索,フォトスタジオ,3Dアート,型取り,全国"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://limu-art.com'}/store-search`}
      />
      
      <div className="min-h-screen bg-white">
        {/* ヘッダー */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100">
          <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-[#1e2a1e]" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
              LiMU
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/#concept" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>コンセプト</Link>
              <Link to="/#story" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>ストーリー</Link>
              <Link to="/#flow" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>制作の流れ</Link>
              <Link to="/#products" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>商品紹介</Link>
              <Link to="/store-search" className="text-[#5a7d5a] font-medium cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>店舗検索</Link>
              <Link to="/#contact" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>仮予約フォーム</Link>
            </div>
            <button className="md:hidden text-[#1e2a1e]">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </nav>
        </header>

        {/* メインコンテンツ */}
        <main className="pt-20">
          {/* ヒーローセクション */}
          <section className="py-16 bg-[#f1f7f3]">
            <div className="max-w-6xl mx-auto px-6 text-center">
              <div className="flex items-center justify-center mb-8">
                <img 
                  src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/6730553a814a60e7987e75933316fd6a.jpeg"
                  alt="LiMUロゴ"
                  className="w-20 h-20 rounded-full object-cover mr-4"
                />
                <h1 className="text-4xl font-bold text-[#1e2a1e]" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
                  店舗検索
                </h1>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#e6f1ea] max-w-2xl mx-auto">
                <p className="text-lg text-[#1e2a1e] mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  LiMU薬品全店舗数 <span className="font-bold text-2xl text-[#5a7d5a]">{totalStores}</span>店舗
                </p>
                <p className="text-sm text-[#4a5a4a] mb-6" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  (2025年10月31日現在)
                </p>
                
                <form onSubmit={handleSearch} className="relative">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="店舗名・住所で検索"
                    className="w-full px-6 py-4 pr-16 border border-[#e6f1ea] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5a7d5a] text-lg"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                  />
                  <button
                    type="submit"
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] text-white rounded-lg hover:bg-[#4a6d4a] transition-colors flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-search-line text-xl"></i>
                  </button>
                </form>
              </div>
            </div>
          </section>

          {/* 地図セクション */}
          <section className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="relative">
                {/* 日本地図の背景 */}
                <div 
                  className="w-full h-[800px] bg-cover bg-center bg-no-repeat rounded-2xl relative overflow-hidden"
                  style={{
                    backgroundImage: `url('https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/dcf0a9cbe892fc8aa9ed2d5ce6e83023.png')`
                  }}
                >
                  {/* 都道府県ボタンのオーバーレイ */}
                  <div className="absolute inset-0">
                    {/* 北海道 */}
                    <button 
                      className="absolute top-8 right-32 bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('北海道')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      北海道<br />(0)
                    </button>

                    {/* 東北地方 */}
                    <button 
                      className="absolute top-24 right-20 bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('青森県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      青森県<br />(0)
                    </button>
                    
                    <button 
                      className="absolute top-32 right-16 bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('岩手県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      岩手県<br />(0)
                    </button>

                    {/* 関東地方 */}
                    <button 
                      className="absolute top-80 right-24 bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('茨城県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      茨城県<br />(0)
                    </button>

                    {/* 中部地方 */}
                    <button 
                      className="absolute top-64 left-80 bg-green-300 hover:bg-green-400 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('石川県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      石川県<br />(17)
                    </button>

                    <button 
                      className="absolute top-72 left-88 bg-green-400 hover:bg-green-500 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('福井県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      福井県<br />(24)
                    </button>

                    <button 
                      className="absolute top-56 left-72 bg-pink-300 hover:bg-pink-400 text-pink-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('長野県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      長野県<br />(49)
                    </button>

                    <button 
                      className="absolute top-68 left-64 bg-pink-300 hover:bg-pink-400 text-pink-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('岐阜県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      岐阜県<br />(42)
                    </button>

                    <button 
                      className="absolute top-80 left-56 bg-pink-400 hover:bg-pink-500 text-pink-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('静岡県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      静岡県<br />(205)
                    </button>

                    <button 
                      className="absolute top-76 left-72 bg-blue-300 hover:bg-blue-400 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('愛知県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      愛知県<br />(76)
                    </button>

                    {/* 関西地方 */}
                    <button 
                      className="absolute top-88 left-80 bg-blue-300 hover:bg-blue-400 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('三重県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      三重県<br />(24)
                    </button>

                    <button 
                      className="absolute top-84 left-88 bg-blue-300 hover:bg-blue-400 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('滋賀県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      滋賀県<br />(19)
                    </button>

                    <button 
                      className="absolute top-80 left-96 bg-blue-400 hover:bg-blue-500 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('京都府')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      京都府<br />(86)
                    </button>

                    <button 
                      className="absolute top-88 left-96 bg-blue-300 hover:bg-blue-400 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('大阪府')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      大阪府<br />(26)
                    </button>

                    <button 
                      className="absolute top-92 left-72 bg-blue-400 hover:bg-blue-500 text-blue-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('兵庫県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      兵庫県<br />(50)
                    </button>

                    {/* 中国・四国地方 */}
                    <button 
                      className="absolute top-96 left-64 bg-green-300 hover:bg-green-400 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('鳥取県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      鳥取県<br />(14)
                    </button>

                    <button 
                      className="absolute top-100 left-56 bg-green-300 hover:bg-green-400 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('島根県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      島根県<br />(9)
                    </button>

                    <button 
                      className="absolute top-104 left-72 bg-green-400 hover:bg-green-500 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('岡山県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      岡山県<br />(29)
                    </button>

                    <button 
                      className="absolute top-108 left-64 bg-green-400 hover:bg-green-500 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('広島県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      広島県<br />(30)
                    </button>

                    <button 
                      className="absolute top-112 left-56 bg-green-300 hover:bg-green-400 text-green-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('山口県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      山口県<br />(7)
                    </button>

                    {/* 四国 */}
                    <button 
                      className="absolute top-116 left-80 bg-yellow-300 hover:bg-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('徳島県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      徳島県<br />(33)
                    </button>

                    <button 
                      className="absolute top-112 left-88 bg-yellow-300 hover:bg-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('香川県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      香川県<br />(29)
                    </button>

                    <button 
                      className="absolute top-120 left-84 bg-yellow-300 hover:bg-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('愛媛県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      愛媛県<br />(12)
                    </button>

                    <button 
                      className="absolute top-124 left-92 bg-yellow-300 hover:bg-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('高知県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      高知県<br />(35)
                    </button>

                    {/* 九州 */}
                    <button 
                      className="absolute top-128 left-48 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('福岡県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      福岡県<br />(116)
                    </button>

                    <button 
                      className="absolute top-132 left-40 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('佐賀県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      佐賀県<br />(77)
                    </button>

                    <button 
                      className="absolute top-136 left-32 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('長崎県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      長崎県<br />(86)
                    </button>

                    <button 
                      className="absolute top-140 left-48 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('熊本県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      熊本県<br />(80)
                    </button>

                    <button 
                      className="absolute top-136 left-64 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('大分県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      大分県<br />(56)
                    </button>

                    <button 
                      className="absolute top-144 left-64 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('宮崎県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      宮崎県<br />(49)
                    </button>

                    <button 
                      className="absolute top-148 left-56 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('鹿児島県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      鹿児島県<br />(55)
                    </button>

                    <button 
                      className="absolute bottom-8 left-16 bg-purple-300 hover:bg-purple-400 text-purple-800 px-2 py-1 rounded text-xs transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => setSelectedPrefecture('沖縄県')}
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      沖縄県<br />(43)
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 地域別リスト */}
          <section className="py-16 bg-[#f1f7f3]">
            <div className="max-w-6xl mx-auto px-6">
              <h2 className="text-3xl font-normal text-[#1e2a1e] mb-12 text-center" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
                地域別店舗一覧
              </h2>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {regions.map((region, index) => (
                  <div key={index} className="bg-white rounded-2xl p-6 border border-[#e6f1ea]">
                    <h3 className="text-xl font-medium text-[#1e2a1e] mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                      {region.name}
                    </h3>
                    <div className="space-y-2">
                      {region.prefectures.map((prefecture, prefIndex) => (
                        <button
                          key={prefIndex}
                          onClick={() => setSelectedPrefecture(prefecture.name)}
                          className={`w-full text-left px-4 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${prefecture.color} hover:opacity-80`}
                          style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                        >
                          <span className="font-medium">{prefecture.name}</span>
                          <span className="float-right">({prefecture.count})</span>
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* 選択された都道府県の詳細 */}
          {selectedPrefecture && (
            <section className="py-16 bg-white">
              <div className="max-w-6xl mx-auto px-6">
                <h2 className="text-3xl font-normal text-[#1e2a1e] mb-8 text-center" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
                  {selectedPrefecture}の店舗
                </h2>
                
                <div className="bg-[#f1f7f3] rounded-2xl p-8 text-center">
                  <i className="ri-store-line text-6xl text-[#5a7d5a] mb-4"></i>
                  <h3 className="text-2xl font-medium text-[#1e2a1e] mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {selectedPrefecture}の店舗情報
                  </h3>
                  <p className="text-[#4a5a4a] mb-6" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    現在、{selectedPrefecture}の詳細な店舗情報を準備中です。<br />
                    お近くの店舗については、仮予約フォームよりご連絡ください。
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link 
                      to="/#contact"
                      className="bg-[#5a7d5a] text-white px-8 py-3 rounded-xl font-medium hover:bg-[#4a6d4a] transition-colors cursor-pointer whitespace-nowrap"
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      仮予約フォーム
                    </Link>
                    <button
                      onClick={() => setSelectedPrefecture(null)}
                      className="bg-white text-[#5a7d5a] border-2 border-[#5a7d5a] px-8 py-3 rounded-xl font-medium hover:bg-[#5a7d5a] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    >
                      地図に戻る
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}
        </main>

        {/* フッター */}
        <footer className="bg-[#1e2a1e] text-white py-16">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ブランド</h4>
                <ul className="space-y-2 text-white/80">
                  <li><Link to="/#concept" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>コンセプト</Link></li>
                  <li><Link to="/#story" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ブランドストーリー</Link></li>
                  <li><Link to="/#voices" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>お客様の声</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>サービス</h4>
                <ul className="space-y-2 text-white/80">
                  <li><Link to="/#products" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>商品紹介</Link></li>
                  <li><Link to="/#flow" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>制作の流れ</Link></li>
                  <li><Link to="/store-search" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>店舗検索</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>サポート</h4>
                <ul className="space-y-2 text-white/80">
                  <li><Link to="/#contact" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>仮予約フォーム</Link></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-white/20 pt-8">
              <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>コピーライト</h4>
              <div className="flex flex-col md:flex-row justify-between items-center">
                <p className="text-white/60 text-sm" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  © 2024 LiMU. All rights reserved.
                </p>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer mt-4 md:mt-0"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

